import { ApiError, NetworkError } from './api';

// Qué hacer ante una falla, según su causa (UX-ERR-01). Cada pantalla dice qué no se pudo
// hacer ("No se pudieron cargar los comentarios.") y agrega este consejo: así un error del
// servidor no se presenta como un problema de la conexión del usuario.

const SUPPORT = 'Vuelve a intentar y, si persiste, contacta a soporte';

const STATUS_ADVICE: Record<number, string> = {
  // La app ya redirige al inicio de sesión ante un 401 (api.ts).
  401: 'Tu sesión venció. Se abrirá el inicio de sesión.',
  403: 'Tu usuario no tiene permiso. Si lo necesitas, pídelo al administrador del sistema.',
  404: 'El servidor no lo encontró. Actualiza la página.',
  429: 'Hay demasiadas solicitudes seguidas. Espera un momento y vuelve a intentar.',
  503: 'El servicio no está disponible por ahora. Vuelve a intentar en unos minutos.',
};

export function errorAdvice(err: unknown): string {
  // Solo una petición que no llegó al servidor es un problema de conexión.
  if (err instanceof NetworkError) {
    return 'Revisa la conexión y vuelve a intentar.';
  }
  if (!(err instanceof ApiError)) {
    // Respuesta con forma inesperada (contrato) o error de programación.
    return `Ocurrió un error inesperado. ${SUPPORT}.`;
  }
  const byStatus = STATUS_ADVICE[err.status];
  if (byStatus !== undefined) {
    return byStatus;
  }
  const code = err.correlationId ? ` con el código ${err.correlationId}` : '';
  if (err.status >= 500) {
    return `El servidor tuvo un problema. ${SUPPORT}${code}.`;
  }
  // Otro rechazo sin texto propio: no se pide recargar (borraría lo escrito en un formulario).
  return `Revisa los datos y vuelve a intentar. Si persiste, contacta a soporte${code}.`;
}

/** Tras una recarga fallida con datos en pantalla ("Se muestran los anteriores"): sin red o
 *  con el servidor caído basta "Reintentar"; si reintentar no lo resuelve (sin permiso, no
 *  encontrado, sesión vencida) se dice qué hacer. Devuelve el texto con espacio inicial. */
export function refreshAdvice(err: unknown): string {
  return err instanceof ApiError && err.status < 500 ? ` ${errorAdvice(err)}` : '';
}
